import script from "./meetingMgmt.vue?vue&type=script&setup=true&lang=js"
export * from "./meetingMgmt.vue?vue&type=script&setup=true&lang=js"

import "./meetingMgmt.vue?vue&type=style&index=0&id=36e6c334&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36e6c334"]])

export default __exports__